import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { IGlobalData } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import { bfk_J1 } from "../../../modules/Beräkningsmoduler/BFK_J1";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";
import { Card, Table } from "react-bootstrap";
import { numFrmtStd } from "../../../modules/common";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFK_J1 = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  const bm = bfk_J1().getResult(module, bimHandler, roundHandler, global.data as IGlobalData);
  const dataExport = bm.data.export;
  const harUppdaterats = dataExport.uppdateratKylmaskin;
  const statistikUppdateradText = dataExport.statistikUppdateradText;
  const uppmättKylfaktor = dataExport.uppmättKylfaktor;

  const funktionsKontroller = bm.funktionsKontroller;

  const systemText = global.beräkningsflikarText.beskr_BFK_J1;

  return (
    <div>
      <Card className="mb-3">
        <Card.Header>{systemText?.title}</Card.Header>
        <Card.Body>
          <div dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />
          <Card className="mb-3">
            <Card.Header>
              <div>Ytterligare information</div>
            </Card.Header>
            <div className="">
              <Table className="w-auto" bordered hover>
                <tbody>
                  <tr>
                    <td colSpan={2}>{statistikUppdateradText}</td>
                  </tr>
                  <tr className="w-auto">
                    {harUppdaterats === "Ja" ? (
                      <>
                        <td>Uppmätt kylfaktor (η)</td>
                        <td className="w-auto">{numFrmtStd.format(uppmättKylfaktor)}</td>
                      </>
                    ) : (
                      <>
                        <td colSpan={2}>Uppmätt kylfaktor saknas</td>
                      </>
                    )}
                  </tr>
                </tbody>
              </Table>
            </div>
          </Card>
          <Funktionskontroller bfName="BFK_J1" formHook={formHook} funktionsKontroller={funktionsKontroller} />
          <BFLNote formHook={formHook} />
          <ErrorInfo info={bm.error} />
          <DebugInfo info={bm.debug} />
        </Card.Body>
      </Card>
    </div>
  );
};

export default BFK_J1;
